import { render, staticRenderFns } from "./Statements-list.vue?vue&type=template&id=6125d5bf"
import script from "./Statements-list.vue?vue&type=script&lang=js"
export * from "./Statements-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports